import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { useParams } from 'react-router-dom'
import { FormSimplePersistenceDefaultValue } from '../../../../../../shared/form-simple/form-persistence-default-value'
import { useApiFormSaveItem } from '../../../../../../api-new/state/content'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'

export const NodeSaveItemEdit = ({ nodeID, parentURL }) => {
  const { id } = useParams()

  const apiFormSaveItem = useApiFormSaveItem()

  const roleOrgNode = useRoleOrgNode()

  const handleMatch = () => apiFormSaveItem.get(id)

  const handleSubmit = data => apiFormSaveItem.put(`${data.id}`, data)

  return (
    <BreadcrumbView Icon={IconEdit} text="Edit configuration" onMatch={handleMatch}>
      <CardFullHeightScrollY>
        <Card title="edit configuration">
          <FormSimple state={apiFormSaveItem.form} disabled={!roleOrgNode.accessUpdate} onSubmit={handleSubmit}>
            <FormSimpleText name="name" required readonly />
            <FormSimpleText name="type" required readonly />
            <FormSimplePersistenceDefaultValue name="value" type={apiFormSaveItem.form.type} required />
            <FormSimpleSubmitEdit backURL={parentURL} />
          </FormSimple>
        </Card>
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
